import * as URL from "../../helpers/Constants";
import axios from "axios";

export default class PMSPatientPrescriptionServices {

    static getAllPrescriptions(pharmacyId, params) {
        return axios.get(`${URL.PMS_GET_ALL_PRESCRIPTIONS}/${pharmacyId}`, {
            ...PMSPatientPrescriptionServices.getAuthHeader(),
            params,
        });
    }

    static getPrescriptionById(id, pharmacyId) {
        return axios.get(`${URL.PMS_GET_PRESCRIPTION_BY_ID}/${id}/${pharmacyId}`,
            PMSPatientPrescriptionServices.getAuthHeader());
    }

    static createPrescription(pharmacyId, data) {
        return axios.post(`${URL.PMS_CREATE_PRESCRIPTION}/${pharmacyId}`, data,
            PMSPatientPrescriptionServices.getAuthHeader());
    }

    static updatePrescriptionById(id, pharmacyId, data) {
        return axios.put(`${URL.PMS_UPDATE_PRESCRIPTION}/${id}/${pharmacyId}`, data,
            PMSPatientPrescriptionServices.getAuthHeader());
    }

    static deletePrescriptionById(id, pharmacyId) {
        return axios.delete(`${URL.PMS_DELETE_PRESCRIPTION}/${id}/${pharmacyId}`,
            PMSPatientPrescriptionServices.getAuthHeader());
    }

    static getAuthHeader() {
        return {headers: {Authorization: `Bearer ${localStorage.getItem("oushodsheba_access_token")}`}};
    }
}
